<template>
	<div>
		<Modal v-model="modal.ifShow" :title="modal.Title" width="40%" :mask-closable="false" :closable="false">
			<!--控件添加修改-->
			<Form :rules="ruleInline" label-position="right"
				v-if="modal.type=='add'||modal.type=='up'||modal.type=='view'" ref="refForm" :model="modalInfo"
				:label-width="120">
				<Row v-show='false' :gutter="24" style="margin-bottom: 10px;">
					<Col :span="6">
					<FormItem label="Id" prop="Id">
						<Input :disabled="modal.canInput" v-model="modalInfo.Id" placeholder="Id"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row :gutter="24" style="margin-bottom: 10px;">
					<Col :span="12">
					<FormItem :label="$tt('关联运营商')" prop="OperatorId">
						<Select filterable :disabled="modal.canInput" :placeholder="$tt('关联运营商')" v-model="modalInfo.OperatorId">
							<Option v-bind:key="item.Id" v-for="(item) in OperatortypeList" :value="item.Id">{{item.Name}}</Option>
						</Select>
					</FormItem>
					</Col>
					<Col :span="12">
					<FormItem :label="$tt('商户类型')" prop="MchType">
						<!-- 0-未知；1-支付宝；2-微信；3-威富通；4-农行商户；50-非商户分界值；100-互联互通 -->
						<Select :disabled="modal.canInput" :placeholder="$tt('商户类型')" v-model="modalInfo.MchType">
							<Option :value='0'>{{$tt('未知')}}</Option>
							<Option :value='1'>{{$tt('支付宝')}}</Option>
							<Option :value='2'>{{$tt('微信')}}</Option>
							<Option :value='3'>{{$tt('威富通')}}</Option>
							<Option :value='4'>{{$tt('农行商户')}}</Option>
						</Select>
					</FormItem>
					</Col>
				</Row>
				<Row :gutter="24">
					<Col :span="12">
					<FormItem :label="$tt('商户名称')" prop="Name">
						<Input :disabled="modal.canInput" v-model="modalInfo.Name" :placeholder="$tt('商户名称')"></Input>
					</FormItem>
					</Col>
					<Col :span="12">
					<FormItem label="appId" prop="AppId">
						<Input :disabled="modal.canInput" v-model="modalInfo.AppId" placeholder="appId"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row :gutter="24">
					<Col :span="12">
					<FormItem :label="$tt('商户号')" prop="MchId">
						<Input :disabled="modal.canInput" v-model="modalInfo.MchId" :placeholder="$tt('商户号')"></Input>
					</FormItem>
					</Col>
					<Col :span="12">
					<FormItem :label="$tt('子商户号')" prop="SubMchId">
						<Input :disabled="modal.canInput" v-model="modalInfo.SubMchId" :placeholder="$tt('子商户号')"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row :gutter="24">
					<Col :span="12">
					<FormItem :label="$tt('证书密码')" prop="CertPwd">
						<Input v-if="modal.type=='up'" type="password" :disabled="modal.canInput"
							v-model="modalInfo.CertPwd" :placeholder="$tt('证书密码')"></Input>
						<Input v-else :disabled="modal.canInput" v-model="modalInfo.CertPwd" :placeholder="$tt('证书密码')"></Input>
					</FormItem>
					</Col>
					<Col :span="12">
					<FormItem :label="$tt('签名算法')" prop="SignType">
						<Select :disabled="modal.canInput" :placeholder="$tt('签名算法')" v-model="modalInfo.SignType">
							<Option value='HMAC-SHA256'>HMAC-SHA256</Option>
							<Option value='MD5'>MD5</Option>
						</Select>
					</FormItem>
					</Col>
				</Row>
				<Row :gutter="24">
					<Col :span="24">
					<FormItem :label="$tt('商户密钥')" prop="MchKey">
						<Input v-if="modal.type=='up'" type="password" :disabled="modal.canInput"
							v-model="modalInfo.MchKey" :placeholder="$tt('商户密钥')"></Input>
						<Input v-else :disabled="modal.canInput" v-model="modalInfo.MchKey" :placeholder="$tt('商户密钥')"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row :gutter="24">
					<Col :span="24">
					<FormItem :label="$tt('证书路径')" prop="CertFile">
						<Input style="margin-bottom: 5px;" :disabled="modal.canInput" v-model="modalInfo.CertFile"
							:placeholder="$tt('证书路径')"></Input>
						<Upload name="UpFile" :show-upload-list="false" :format="['p12']" :action="uploadCertFileUrl"
							:headers="upHeader" :on-format-error="formatError" :before-upload="uploadBefore"
							:on-error="uploadError" :on-success="uploadSuccess">
							<Button icon="ios-cloud-upload-outline">{{$tt('点击上传文件')}}</Button>
						</Upload>
					</FormItem>
					</Col>
				</Row>
				<Row :gutter="24">
					<Col :span="24">
					<FormItem :label="$tt('支付结果通知url')" prop="PayNotifyUrl">
						<Input :disabled="modal.canInput" v-model="modalInfo.PayNotifyUrl"
							:placeholder="$tt('支付结果通知url')"></Input>
					</FormItem>
					</Col>
				</Row>
				<!-- <Row :gutter="24">
					<Col :span="12">
					<FormItem :label="$tt('建档人')" prop="Creator">
						<Input :disabled="true" v-model="modalInfo.Creator" :placeholder="$tt('建档人')"></Input>
					</FormItem>
					</Col>
					<Col :span="12">
					<FormItem :label="$tt('建档时间')" prop="CreateTime">
						<Input :disabled="true" v-model="modalInfo.CreateTime" :placeholder="$tt('建档时间')"></Input>
					</FormItem>
					</Col>
				</Row> -->
				<!-- <Row :gutter="24">
					<Col :span="12">
					<FormItem :label="$tt('修改人')" prop="Modifier">
						<Input :disabled="true" v-model="modalInfo.Modifier" :placeholder="$tt('修改人')"></Input>
					</FormItem>
					</Col>
					<Col :span="12">
					<FormItem :label="$tt('修改时间')" prop="ModifyTime">
						<Input :disabled="true" v-model="modalInfo.ModifyTime" :placeholder="$tt('修改时间')"></Input>
					</FormItem>
					</Col>
				</Row> -->
				<Row :gutter="24">
					<Col :span="24">
					<FormItem :label="$tt('备注')" prop="Remark">
						<Input :disabled="modal.canInput" v-model="modalInfo.Remark" :placeholder="$tt('备注')"></Input>
					</FormItem>
					</Col>
				</Row>
			</Form>
			<div v-if="modal.type=='add'" slot="footer">
				<Button type="warning" size="large" @click="modalOk('cancle')">{{$tt('取消')}}</Button>
				<Button type="success" size="large" @click="modalOk('add')">{{$tt('添加')}}</Button>
			</div>
			<div v-if="modal.type=='up'" slot="footer">
				<Button type="warning" @click="modalOk('cancle')" size="large">{{$tt('取消')}}</Button>
				<Button type="success" @click="modalOk('up')" size="large">{{$tt('修改')}}</Button>
			</div>
			<div v-if="modal.type=='view'" slot="footer">
				<Button type="success" @click="modalOk('cancle')" size="large">{{$tt('关闭')}}</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import dateFormat from '../../../../../public/js/comm.js'
	import webapi from '../../../../webapi.js';
	export default {
		data() {
			return {
				uploadCertFileUrl: webapi.base_api_url + '/Common/UploadCertFile',
				modal: {
					Title: this.$tt('事件添加'),
					type: "add",
					ifShow: false,
					canInput: false
				},
				//添加会员model
				modalInfo: {
					//Id
					// 关联的运营商
					// 商户类型
					// 商户类型描述
					// 商户名称
					// 公众号或appId

					// 商户号
					// 子商户号

					//商户密钥

					// 证书路径         
					// 证书密码

					// 签名算法

					// 支付结果通知url

					// 备注
					// 建档人
					// 建档人
					// 建档时间
					// 修改人
					// 修改人
					// 修改时间
					Id: 0,
					OperatorId: 0,
					MchType: 2,
					//MchTypeDesc:'',
					Name: '',
					AppId: '',

					MchId: '',
					SubMchId: '',

					MchKey: '',

					CertFile: '',
					CertPwd: '',

					SignType: 'HMAC-SHA256',

					PayNotifyUrl: '',

					//CreateBy:'',
					Creator: '',
					CreateTime: '',
					//ModifyBy:'',
					Modifier: '',
					ModifyTime: ''
				},

				/******分割线********/
				upHeader: {
					'Authorization': "Bearer " + encodeURIComponent(localStorage.AccessToken)
				},

				//校验字段
				ruleInline: {
					// Name: [{
					// 	validator: validateOpId,
					// 	trigger: 'blur',
					// }],
					StationId: [{
						required: true,
						message: this.$tt('控件名称'),
						trigger: 'change',
						type: 'number'
					}],
					EventCode: [{
						required: true,
						message: this.$tt('显示名称'),
						trigger: 'change',
						type: 'number'
					}],
				},
			};
		},

		methods: {
			//打开新增会员
			show: function(type, params) {
				const _this = this;
				if (type == "add") {
					_this.modal.Title = this.$tt('商户添加');
					_this.modal.type = "add";
					this.modal.canInput = false
					_this.$refs.refForm.resetFields()
				} else if (type == "up") {
					_this.modal.Title = this.$tt('商户信息修改');
					_this.modal.type = "up";
					_this.modalInfo = {
						Id: params.Id,
						OperatorId: params.OperatorId,
						MchType: params.MchType,
						//MchTypeDesc:'',
						Name: params.Name,
						AppId: params.AppId,

						MchId: params.MchId,
						SubMchId: params.SubMchId,

						MchKey: params.MchKey,

						CertFile: params.CertFile,
						CertPwd: params.CertPwd,

						SignType: params.SignType,

						PayNotifyUrl: params.PayNotifyUrl,

						Creator: params.Creator,
						CreateTime: params.CreateTime,

						Modifier: params.Modifier,
						ModifyTime: params.ModifyTime
					}
					this.modal.canInput = false
				} else if (type == "view") {
					_this.modal.Title = this.$tt('商户信息查看');
					_this.modal.type = "view";
					_this.modalInfo = {
						Id: params.Id,
						OperatorId: params.OperatorId,
						MchType: params.MchType,
						//MchTypeDesc:'',
						Name: params.Name,
						AppId: params.AppId,

						MchId: params.MchId,
						SubMchId: params.SubMchId,

						MchKey: dateFormat.textReplace(params.MchKey, 3, 3, '*'),

						CertFile: params.CertFile,
						CertPwd: dateFormat.textReplace(params.CertPwd, 3, 3, '*'),

						SignType: params.SignType,

						PayNotifyUrl: params.PayNotifyUrl,

						Creator: params.Creator,
						CreateTime: params.CreateTime,

						Modifier: params.Modifier,
						ModifyTime: params.ModifyTime
					}
					this.modal.canInput = true
				}
				_this.modal.ifShow = true
			},
			//model操作
			modalOk: function(type) {
				const _this = this
				switch (type) {
					case 'cancle':
						_this.modal.ifShow = false
						break;
					case 'add':
						_this.modal.ifShow = true
						_this.addAndUp('add');
						break;
					case 'up':
						_this.modal.ifShow = true
						_this.addAndUp('up');
						break;
					default:
						break;
				}
			},
			//添加
			addAndUp: function(type) {
				const _this = this;
				_this.$refs.refForm.validate((valid) => {
					console.log("商户" + type + "----" + valid)
					if (valid) {
						let parms = this.modalInfo
						_this.$axios.post(webapi.base_api_url + "/Archives/AddPaymentMerchant", parms, {})
							.then(
								res => {
									console.log("新增&修改事件")
									console.log(res.data)
									if (res.data.Code == 0) {
										this.$Message.success(this.$tt('操作成功'));
										_this.$emit('handleSubmit');
										_this.modalOk("cancle")
									} else {
										this.$Message.success(res.data.Msg + "---" + res.data.Data);
									}
								})
					}
				})
			},
			/**********图片组件方法*************/
			//上传文件
			uploadSuccess: function(response, file, fileList) {
				console.log("上传文件成功")
				this.modalInfo.CertFile = response.Data
				//console.log(response)
			},
			//上传文件error
			uploadError: function(response, file, fileList) {
				this.$Message.error(this.$tt('上传文件失败'))
			},
			//上传文件检查
			uploadBefore: function(file) {
				// if (this.formInline.FileVersion == '') {
				// 	this.$Message.error(this.$tt('请填写文件版本号'))
				// 	return false;
				// }
			},
			formatError: function(file, fileList) {
				this.$Message.error(this.$tt('文件格式为.p12'))
			},
		},
		mounted() {},
		computed: {
			//直接选属性
			...mapState({
				StationList: 'Stations',
				OperatortypeList: 'typeList',
			})
		}
	}
</script>

<style>
</style>
